import { VirtualElement } from '@popperjs/core';
import { createContext } from 'react';

export const popperReferenceContext = createContext<React.MutableRefObject<Element | VirtualElement | null>>({ current: null });
